import React, { useEffect, useState } from 'react'
import Index from './pages/Index/Index'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CssBaseline, ThemeProvider } from '@mui/material'
import useTheme from './hooks/useTheme'
import Maintenance from './pages/Maintenance/Maintenance'
import { useWindowSize } from '@uidotdev/usehooks'

const App = () => {
  const { toggleDarkMode, theme, darkMode } = useTheme()
  const [maintenanceMode, setMaintenanceMode] = useState(true)

  const { width } = useWindowSize()
  const isMobileDevice = width !== null && width < 800

  useEffect(() => {
    if (!maintenanceMode) toast.info('Você pode navegar pelas seções através do menu abaixo')
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer
        position="top-right"
        autoClose={9000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={darkMode ? "dark" : "light"}
        closeButton={false}
      />
      {maintenanceMode ? <Maintenance isMobileDevice={isMobileDevice} /> : <Index toggleDarkMode={toggleDarkMode} isMobileDevice={isMobileDevice} />}
    </ThemeProvider>
  )
}

export default App
